// extracted by mini-css-extract-plugin
export default {"chatRow":"chatbubble_chatRow__BUz4v","botImg":"chatbubble_botImg__DLHLq","bubble":"chatbubble_bubble__icWxU"};